// removed by extract-text-webpack-plugin
module.exports = {"chart":"chart__1pKdZ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayFreqPie/styles.scss
// module id = 2262
// module chunks = 1